import React, { Component } from 'react'

class GoogleTranslate extends Component {
  render() {
    return (
      <div>
        <div id='google_translate_element'></div>

        <div className='translate notranslate'>
          <select>
            <option value=''>Choose a Language</option>
            <option value='en'>English</option>
            <option value='es'>Spanish</option>
            <option value='zh-TW'>Chinese (Traditional)</option>
            <option value='zh-CN'>Chinese (Simplified)</option>
            <option value='vi'>Vietnamese</option>
            <option value='so'>Somali</option>
            <option value='am'>Amharic</option>
            <option value='ko'>Korean</option>
            <option value='ru'>Russian</option>
            <option value='tl'>Filipino</option>
            <option value='ar'>Arabic</option>
            <option value='km'>Khmer</option>
            <option value='th'>Thai</option>
            <option value='lo'>Lao</option>
            <option value='ja'>Japanese</option>
            <option value='fr'>French</option>
            <option value='de'>German</option>
          </select>
          <div className='translate__disclaimer'>
            <a target='blank' href='//www.seattle.gov/about-our-digital-properties/content-policies#translation'>Google Translate Disclaimer</a>
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleTranslate;